/**
 * What a small orange count badge says — "3", capped at "9+" — or null to hide
 * it at none. Ported from iOS `CountBadgeLabel`: the Chat button's unread count
 * and the trip home's Join requests both read this way.
 */
export const countBadgeText = (count: number): string | null => {
	if (count <= 0) return null
	return count > 9 ? '9+' : String(count)
}
